import { ChosenLeaseCar } from 'types';

import {
	ChosenLeaseCarActionTypes,
	RESET_CHOSENLEASECAR,
	SET_CHECKOUT_BEGINS,
	SET_COLOR,
	SET_DURATION,
	SET_KILOMETRAGE,
	SET_OPTIONS_AND_ACCESSOIRES,
	SET_PAYMENT_IN_ADVANCE_AMOUNT,
	SET_PAYMENT_IN_ADVANCE_CHOICE,
	SET_PRICE_POINT_ID,
	SET_PRICE_POINT_PRICE,
	SET_SERVICES,
	SET_TOTAL_PRICE,
	SET_UPGRADE,
} from '../actions/chosenLeaseCarActionTypes';

export const initialState: ChosenLeaseCar = {
	options: [],
	services: [],
	upgrade: undefined,
	color: undefined,
	duration: '',
	kilometrage: '',
	pricePointId: 0,
	pricePointPrice: 0,
	totalPrice: 0,
	checkoutBegins: false,
	paymentInAdvanceAmount: undefined,
	paymentInAdvanceChoice: false,
};

const chosenLeaseCar = (
	state: ChosenLeaseCar = initialState,
	action: ChosenLeaseCarActionTypes
): ChosenLeaseCar => {
	switch (action.type) {
		case SET_OPTIONS_AND_ACCESSOIRES:
			return {
				...state,
				options: action.payload,
			};
		case SET_UPGRADE:
			return {
				...state,
				upgrade: action.payload,
			};
		case SET_SERVICES:
			return {
				...state,
				services: action.payload,
			};
		case SET_COLOR:
			return {
				...state,
				color: action.payload,
			};
		case SET_DURATION:
			return {
				...state,
				duration: action.payload,
			};
		case SET_KILOMETRAGE:
			return {
				...state,
				kilometrage: action.payload,
			};
		case SET_PRICE_POINT_ID:
			return {
				...state,
				pricePointId: action.payload,
			};
		case SET_PRICE_POINT_PRICE:
			return {
				...state,
				pricePointPrice: action.payload,
			};
		case SET_TOTAL_PRICE:
			return {
				...state,
				totalPrice: action.payload,
			};
		case SET_CHECKOUT_BEGINS:
			return {
				...state,
				checkoutBegins: action.payload,
			};
		case SET_PAYMENT_IN_ADVANCE_AMOUNT:
			return {
				...state,
				paymentInAdvanceAmount: action.payload,
			};
		case SET_PAYMENT_IN_ADVANCE_CHOICE:
			return {
				...state,
				paymentInAdvanceChoice: action.payload,
			};
		case RESET_CHOSENLEASECAR:
			return initialState;
		default:
			return state;
	}
};

export default chosenLeaseCar;
